import { z } from "zod";
import { zStringId } from "../../utils";
import { zUserSnippet } from "../users/user-snippet-resource";

export const zReview = z.object({
  _id: zStringId(),
  rating: z.number(),
  reviewText: z.string(),
  publishedAt: z.date(),
  serviceProjectId: zStringId(),
  serviceProjectDoc: z.object({
    serviceId: zStringId(),
    serviceDetails: z.object({
      title: z.string(),
      requiredDays: z.number().optional(),
    }),
  }),
  reviewerDoc: zUserSnippet,
  revieweeDoc: zUserSnippet,
  showOnProfile: z.boolean(),
});

export type Review = z.infer<typeof zReview>;
